export default __webpack_public_path__ + "static/media/094F4D72-9041-40A2-B49C-B37F89976600.7231ea7c.jpg";